/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import { lightTheme, darkTheme } from "assets/theme";
import Presentation from "layouts/pages/presentation";
import PrivacyView from "layouts/pages/privacy";
import ServiceAgreementView from "layouts/pages/serviceagreement";
import MembershipAgreementView from "layouts/pages/membershipagreement";

// Material Kit 2 React routes
// import routes from "routes";

export default function App() {
  const { pathname } = useLocation();
  const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  // const getRoutes = (allRoutes) =>
  //   allRoutes.map((route) => {
  //     if (route.collapse) {
  //       return getRoutes(route.collapse);
  //     }

  //     if (route.route) {
  //       return <Route exact path={route.route} element={route.component} key={route.key} />;
  //     }

  //     return null;
  //   });

  return (
    <ThemeProvider theme={mediaQuery.matches ? darkTheme : lightTheme}>
      <CssBaseline />
      <Routes>
        {/* {getRoutes(routes)} */}
        <Route path="/privacy" element={<PrivacyView />} />
        <Route path="/serviceagreement" element={<ServiceAgreementView />} />
        <Route path="/membershipagreement" element={<MembershipAgreementView />} />
        <Route path="/home" element={<Presentation />} />
        <Route path="*" element={<Navigate to="/home" />} />
      </Routes>
    </ThemeProvider>
  );
}
